<template>
  <div class="personal-r coupon_content">
    <h2><span>礼品券</span><p style="color:gray; font-size: 12px;">预计2024年1月1日开放兑换</p> <span>客服热线：021-20219997</span></h2>
    <div class="coupon_main" v-if="!notData">
      <template v-for="(item, index) in couponList">
        <div class="time_main_coupon" v-if="item.show" :key="'type' + index">
          <div class="header_tit">
            <span>{{ item.title }}</span>
            <span>{{ item.subtitle }}</span>
          </div>
          <div class="list_main">
            <div
              class="list_li"
              v-for="(itemLi, indexLi) in item.list"
              :key="indexLi"
            >
              <div class="left_box">
                <div class="img_box">
                  <img
                    :style="{ width: itemLi.width + 'px' }"
                    :src="handleGiftImg(itemLi.giftId)"
                    alt=""
                  />
                </div>
                <div class="text_tit">{{ itemLi.prizeName }}</div>
              </div>
              <div class="right_box">
                <div class="not_text">{{ itemLi.timeText }}</div>
                <div
                  :class="itemLi.status | handleBtnColor"
                  @click="handleBtnFn(itemLi)"
                >
                  {{ itemLi.status | handleBtnText }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="needing_box" v-if="!notData">
      活动规则：<br>
      1. 本次活动有效期为：2023年11月1日至11月30日；<br>
      2. 活动期间，成为大智慧VIP月卡的用户，即送20G定制银条一根；<br>
      3. 成为大智慧VIP年卡的用户，即送100ML茅台一瓶或100G银条一根，二者任选其一；<br>
      4. 成为大智慧VIP年卡PRO版的用户，即送500ML飞天茅台一瓶或8G定制金条一根，二者任选其一；<br>
      5. 成为大智慧VIP的用户，软件权限需至少满30天才可兑换礼品，用户因任何原因导致退款或大智慧VIP权限被关闭的将不可兑换礼品；<br>
      6. 用户可至个人中心”我的礼券“下看到礼品权益；<br>
      7. 所有实物奖励兑换时间为2024年1月1日—1月31日，期间未兑换领取的礼品券将失效；发货时间为2024年1月31日前；<br>
      8. 如用户拒签/收取实物礼品或未及时签收等导致实物礼品未妥投，默认用户退回并放弃礼品。所有礼品均不可折现提取；<br>
      9. 兑换时填写的信息请务必认真核对，如填写信息有误造成的损失本公司概不负责。<br>
      10.每个用户限领3份；礼品的20%个人所得税由大智慧进行缴纳，用户无需承担该费用，但需提交领取人的实名信息，以便大智慧进行税费缴纳，如因用户未提交真实的实名信息而造成的无法领取礼品，则示为放弃礼品。<br><br>
      活动说明:<br>
      1. 如果下载、参与活动或领取礼品时时因网络异常无法正常继续下一步动作，请在网络正常后重试；系统维护、升级时可能会影响用户的领取状态，等待系统正常后再查询，大智慧不对网络异常、系统维护升级、黑客袭击及其他不可抗力因素造成的活动障碍承担相应责任；<br>
      2. 为保证活动有序进行，如用户存在违反法律法规及本活动规则的行为，侵犯第三人合法权益、扰乱系统、实施网络攻击、恶意套现、刷实物奖励、用机器模拟客户端作弊等，我们有权取消该用户的活动资格或取消、追回该用户通过活动所获得的礼品或权益；<br>
      3. 如果出现包括但不限于以下情形：供应商生产计划变化、系统故障、不可抗力等因素影响，用户所得礼品由于非本公司原因而导致的缺货情况下，会更换等价奖品或以其他有效方式向用户通知并提供解决方案。请用户在未收到礼品之前留意通知；<br>
    </div>
    <div class="not_data_dom" v-if="openActivity && notData">
      <img src="../../assets/images/product/coupon/not_data_img.png" alt="" />
      <p>暂无礼品券</p>
    </div>
    <div class="not_data_dom" v-if="!openActivity">
      <img src="../../assets/images/product/coupon/not_data_img.png" alt="" />
      <p>大智慧VIP礼品权益即将到来，敬请期待</p>
    </div>
    <!-- 以下是弹框样式 -->
    <div
      class="pop_bg"
      v-if="addressPopShow || notRedeemedPop || redeemedPopShow"
    ></div>
    <div class="pop_content_main" v-if="addressPopShow || notRedeemedPop">
      <div class="address_main_prop">
        <header>
          兑奖信息
          <div class="close" @click="close">
            <img src="../../assets/images/product/coupon/close.png" alt="" />
          </div>
        </header>
        <div class="identity_main" v-show="notRedeemedPop">
          <div class="input_main">
            <div class="tit">姓名</div>
            <el-input
              v-model="identityObj.name"
              placeholder="请输入收货人姓名"
            ></el-input>
          </div>
          <div class="input_main">
            <div class="tit">身份证</div>
            <el-input
              v-model="identityObj.identityNum"
              placeholder="请输入收件人身份证号"
            ></el-input>
          </div>
          <!--  -->
          <div class="prompt_dom_text">
            请填写正确的姓名和身份证号，以用于奖品代缴税款，填写的信息请务必认真核对，如填写信息有误造成的损失本公司概不负责。
          </div>
          <div class="next_btn" @click="handleNext">
            下一步
            <div class="reminder_box" v-show="reminderShow">
              请填写完整信息。
            </div>
          </div>
        </div>
        <div class="identity_main" v-show="addressPopShow">
          <div class="input_main">
            <div class="tit">姓名</div>
            <el-input
              v-model="addressObj.name"
              placeholder="请输入收货人姓名"
            ></el-input>
          </div>
          <div class="input_main">
            <div class="tit">收货城市</div>
            <el-input
              v-model="addressObj.city"
              placeholder="请输入收货城市"
            ></el-input>
          </div>
          <div class="input_main">
            <div class="tit">收货地址</div>
            <el-input
              v-model="addressObj.address"
              placeholder="用于接收礼品的地址"
            ></el-input>
          </div>
          <div class="input_main phone_dom">
            <div class="tit">联系电话</div>
            <div class="phone_content">
              <el-input
                v-model="addressObj.phoneNum"
                placeholder="请输入联系电话"
              ></el-input>
              <div class="identifying_box" @click="getIdentifyingCode">
                {{ identifyingText }}
              </div>
            </div>
          </div>
          <div class="input_main phone_dom">
            <div class="tit">短信验证码</div>
            <div class="phone_content">
              <el-input
                v-model="addressObj.verificationCode"
                placeholder="请输入短信验证码"
              ></el-input>
              <div class="bad_dom" v-if="identifyingBadShow">*验证码错误</div>
              <div class="bad_dom" v-if="addressBadShow">*请填写完整信息。</div>
              <div class="bad_dom" v-if="nogetVerifiyingCode">*请先获取验证码。</div>
            </div>
          </div>
          <div class="prompt_dom_text">
            请填写正确的姓名和身份证号，以用于奖品代缴税款，填写的信息请务必认真核对，如填写信息有误造成的损失本公司概不负责。
          </div>
          <div class="food_btn_box">
            <div class="cancel_btn" @click="close">取消</div>
            <div class="confirm_btn" @click="handleExchange">确认兑换</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 已兑换弹框 -->
    <div class="pop_content_main" v-show="redeemedPopShow">
      <div class="address_main_prop">
        <header>
          收货地址
          <div class="close" @click="redeemedPopShow = false">
            <img src="../../assets/images/product/coupon/close.png" alt="" />
          </div>
        </header>
        <div class="identity_main">
          <div class="input_main">
            <div class="tit">姓名</div>
            <div class="text_content">{{ redeemedObj.name }}</div>
          </div>
          <div class="input_main">
            <div class="tit">收货地址</div>
            <div class="text_content">{{ redeemedObj.address }}</div>
          </div>
          <div class="input_main">
            <div class="tit">联系电话</div>
            <div class="text_content">{{ redeemedObj.phone }}</div>
          </div>
          <div class="btn_ok" @click="redeemedPopShow = false">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Coupon",
  data() {
    return {
      chooseItem: {},
      silver20Gram:require("../../assets/images/product/coupon/yintiaoOne.png"),
      silver100Gram:require("../../assets/images/product/coupon/yintiaoOne.png"),
      maotai100ML: require("../../assets/images/product/coupon/maotaiOne.png"),
      gold8Gram: require("../../assets/images/product/coupon/jintiaoOne.png"),
      maotai500ML: require("../../assets/images/product/coupon/maotaiTwo.png"),
      couponList: [],
      notRedeemedPop: false,
      identityObj: {
        name: "",
        identityNum: "",
      },
      reminderShow: false,

      addressPopShow: false,
      addressObj: {
        name: "",
        city: "",
        address: "",
        phoneNum: "",
        verificationCode: "",
      },

      identifyingText: "获取验证码",
      disabled: false,
      identifyingBadShow: false,
      addressBadShow: false,
      nogetVerifiyingCode: false,
      redeemedObj: {
        name: "*小柏",
        address: "上海市浦东新区杨高南路428号由由世纪广场1号楼",
        phone: "185****0952",
      },
      redeemedPopShow: false,

      notData: true,
      openActivity: false,
    };
  },
  filters: {
    handleBtnText: function (str) {
      // （-1、未开放  0、未兑换  1、已兑换  2、已作废）
      switch (str) {
        case "-1":
          return "尚未开放兑换";
          break;
        case "0":
          return "去兑换";
          break;
        case "1":
          return "已兑换";
          break;
        case "2":
          return "已作废";
          break;
        default:
          break;
      }
    },
    handleBtnColor: function (str) {
      switch (str) {
        case "-1":
          return "btn_box nullify_btn";
          break;
        case "0":
          return "btn_box unfinished_btn";
          break;
        case "1":
          return "btn_box finish_btn";
          break;
        case "2":
          return "btn_box nullify_btn";
          break;
        default:
          break;
      }
    },
  },
  mounted: function () {},

  created: function () {
    var params = {
      giftKind: "20231111"
    }
    this.$post("/user/gift",params)
      .then(response => {
        if (response.code === 0) {
          if(response.data && response.data.length>0){
            this.couponList = response.data;
            this.openActivity = true;
            this.notData = false;
          }else{
            this.notData = true;
            this.openActivity = true;
          }
        }else if(response.code === 203){
          this.notData = true;
          this.openActivity = false;
        }else {
          alert(response.msg)
      }
    })
  },
  methods: {
    handleBtnFn: function (item) {
      switch (item.status) {
        case "-1":
          console.log("尚未开放兑换");
          return false;
          break;
        case "0":
          this.chooseItem = item;
          this.showNotRedeemedPop();
          break;
        case "1":
          console.log("已兑换");
          this.redeemedPopShow = true;
          break;
        case "2":
          console.log("已作废");
          return false;
          break;
        default:
          break;
      }
    },
    handleGiftImg: function (str) {
      switch (str) {
        case "10":
          return this.silver20Gram;
          break;
        case "11":
          return this.silver100Gram;
          break;
        case "12":
          return this.maotai100ML;
          break;
        case "13":
          return this.gold8Gram;
          break;
        case "14":
          return this.maotai500ML;
          break;
        default:
          break;
      }
    },
    // 去兑换弹框xianshi
    showNotRedeemedPop: function () {
      console.log("去兑换");
      this.notRedeemedPop = true;
    },
    // 点击下一步
    handleNext: function () {
      let that = this;
      if (that.identityObj.name !== "" && that.identityObj.identityNum !== "") {
        that.reminderShow = false;
        that.notRedeemedPop = false;
        that.addressPopShow = true;
      } else {
        that.reminderShow = true;
      }
    },
    // 获取短信验证码
    getIdentifyingCode: function () {
      let that = this;
      let time = 59;
      if(that.addressObj.phoneNum == "") return;
      if (that.disabled) return;
      that.disabled = true;
      let timer = setInterval(function () {
        // 判断剩余秒数
        if (time == 0) {
          // 清除定时器和复原按钮
          clearInterval(timer);
          that.disabled = false;
          that.identifyingText = "获取验证码";
        } else {
          that.identifyingText = `${time}秒后重新获取`;
          time--;
        }
      }, 1000);
      // this.$get("/user/giftSms?mobile=" + that.addressObj.phoneNum)
      //   .then(response => {
      //     if (response.code !== 0) {
      //       alert(response.msg)
      //     }
      // })
    },
    close: function () {
      let that = this;
      that.identityObj = {
        name: "",
        identityNum: "",
      };
      that.addressObj = {
        name: "",
        address: "",
        phoneNum: "",
        verificationCode: "",
        city: "",
      };
      that.addressPopShow = false;
      that.notRedeemedPop = false;
      that.identifyingBadShow = false;
      that.addressBadShow = false;
      that.nogetVerifiyingCode = false;
    },
    // 确定兑换
    handleExchange: function () {
      let that = this;
      // 验证短信是否正确
      debugger
      if(that.addressObj.name == ""||that.addressObj.address == ""||that.addressObj.phoneNum == ""||that.addressObj.city == ""){
        that.addressBadShow = true;
        return;
      }

      if (that.addressObj.verificationCode == "") {    
        that.identifyingBadShow = true;
        return;
      }
      if (!that.disabled) {    
        that.nogetVerifiyingCode = true;
        return;
      }
      var params = {
        addressObj: this.addressObj,
        identityObj: this.identityObj,
        giftKind: "20231111",
        code: this.chooseItem.code,
      }
      this.$post("/user/giftActivate",params)
        .then(response => {
          if (response.code === 0) {
            that.chooseItem.status = "1";
            that.addressPopShow = false;
            that.notRedeemedPop = false;
            that.identifyingBadShow = false;
          }else {
            alert(response.msg)
        }
      })
      
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/scss/personal.scss";
.personal-r {
  h2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    span {
      &:last-child {
        font-size: 12px;
      }
    }
  }
  .coupon_main {
    margin-bottom: 57px;
    .time_main_coupon {
      .header_tit {
        width: 100%;
        height: 45px;
        background-color: #f5f5f5;
        padding-left: 39px;
        box-sizing: border-box;
        line-height: 45px;
        font-size: 16px;
        color: #333;

        span {
          &:last-child {
            color: #999;
            font-size: 12px;
            margin-left: 13px;
          }
        }
      }
      .list_main {
        padding-left: 40px;
        box-sizing: border-box;
        background-color: #fff;
        border-bottom: 1px solid #e9e9e9;
        border-top: 1px solid #e9e9e9;
        .list_li {
          width: 100%;
          height: 66px;
          border-bottom: 1px solid #e9e9e9;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-right: 36px;
          box-sizing: border-box;
          &:last-child {
            border: none;
          }
          .left_box {
            display: flex;
            align-items: center;
            .img_box {
              width: 45px;
              height: 45px;
              border: 1px solid #e3e3e3;
              text-align: center;
              box-sizing: border-box;
              margin-right: 14px;
              display: flex;
              align-items: end;
              justify-content: center;
            }
            .text_tit {
              font-size: 18px;
              color: #333;
              font-weight: bold;
            }
          }
          .right_box {
            display: flex;
            align-items: center;
            .not_text {
              margin-right: 15px;
              color: #999;
              font-size: 12px;
            }
            .btn_box {
              padding: 6px 25px;
              font-size: 16px;
              font-weight: bold;
              box-sizing: border-box;
              border: 1px solid;
              border-radius: 18px;
              cursor: pointer;
              &.nullify_btn {
                border: 1px solid #bfbfbf;
                color: #bfbfbf;
              }
              &.finish_btn {
                border: 1px solid #999;
                color: #999;
              }
              &.unfinished_btn {
                border: 1px solid #166fff;
                color: #166fff;
              }
            }
          }
        }
      }
    }
  }
  .needing_box {
    font-size: 12px;
    color: #999;
    padding: 0 36px 0 40px;
    box-sizing: border-box;
  }
  .pop_bg {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba($color: #000, $alpha: 0.3);
  }
  .pop_content_main {
    padding: 20px 48px 22px 48px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .address_main_prop {
      width: 444px;
      header {
        margin-bottom: 14px;
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
        position: relative;
        .close {
          width: 24px;
          height: 24px;
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
          text-align: center;
        }
        img {
          width: 10px;
          height: 10px;
        }
      }
      .identity_main {
        .input_main {
          height: 60px;
          width: 100%;
          border-bottom: 1px solid #e9e9e9;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #222;
          font-size: 16px;
          &.phone_dom {
            .phone_content {
              display: flex;
              align-items: center;
              justify-content: center;
              .identifying_box {
                color: #286df7;
                font-size: 15px;
                cursor: pointer;
              }
              .bad_dom {
                color: #ef3939;
              }
            }
          }
          .text_content {
            width: 360px;
            text-align: right;
            color: #333;
            font-size: 16px;
            padding: 0 15px;
            box-sizing: border-box;
          }
        }
        .next_btn {
          width: 154px;
          height: 44px;
          background: #e8f0ff;
          border-radius: 6px;
          font-size: 17px;
          color: #286df7;
          text-align: center;
          line-height: 44px;
          border: 0.5px solid var(--unnamed, #286df7);
          margin-top: 15px;
          cursor: pointer;
          position: relative;
          .reminder_box {
            position: absolute;
            right: -200px;
            top: 0;
            color: red;
            font-size: 20px;
            width: 194px;
          }
        }
        .food_btn_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .cancel_btn {
            width: 154px;
            height: 44px;
            background: #e8f0ff;
            border-radius: 6px;
            font-size: 17px;
            color: #286df7;
            text-align: center;
            line-height: 44px;
            border: 0.5px solid var(--unnamed, #286df7);
            margin-top: 15px;
            cursor: pointer;
            box-sizing: border-box;
          }
          .confirm_btn {
            width: 271px;
            height: 44px;
            border-radius: 6px;
            background: var(--unnamed, #286df7);
            color: #fff;
            font-size: 17px;
            margin-top: 15px;
            text-align: center;
            line-height: 44px;
            cursor: pointer;
          }
        }
        .btn_ok {
          width: 247px;
          height: 44px;
          border-radius: 6px;
          border: 1px solid var(--unnamed, #286df7);
          background: #e8f0ff;
          color: var(--unnamed, #286df7);
          font-size: 17px;
          text-align: center;
          line-height: 44px;
          cursor: pointer;
          margin: 15px auto 0;
        }
        .prompt_dom_text {
          margin-top: 15px;
        }
      }
    }
  }
  .not_data_dom {
    text-align: center;
    padding-top: 100px;
    img {
      width: 150px;
      height: 100px;
    }
    p {
      font-size: 14px;
      color: #333;
      margin-top: 24px;
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
.coupon_content {
  .el-input {
    width: 360px;
  }
  .phone_dom {
    .el-input {
      width: 200px;
    }
  }
  .el-input__inner {
    border: none;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personal/Coupon.vue